import { Prettify } from '../../common/types'
import { IKvitteringData } from '../../ducks/kvittering/types'
import { IVirksomhetTilsynsobjekt } from '../../ducks/virksomhet-search/types'
import { IMidlertidigTilsynsobjektPayload } from '../midlertidig-tilsynsobjekter/types'

export enum KvitteringQueryStatusEnum {
  PENDING = 'pending',
  ERROR = 'error',
  SUCCESS = 'success',
  NONE = 'NONE',
}

export type KvitteringQueryStatus = 'error' | 'success' | 'pending' | 'NONE'

enum TyperTilsyn {
  ANNET = 'ANNET',
  DIGITALT_TILSYN = 'DIGITALT_TILSYN',
  FYSISK_INSPEKSJON = 'FYSISK_INSPEKSJON',
  GODKJENNINGSSOEKNAD = 'GODKJENNINGSSOEKNAD',
  OPPFOELGING_DIGITALT = 'OPPFOELGING_DIGITALT',
  OPPFOELGING_FYSISK = 'OPPFOELGING_FYSISK',
  REGELMESSIG_OFFENTLIG_KONTROLL = 'REGELMESSIG_OFFENTLIG_KONTROLL',
  VERIFIKASJON = 'VERIFIKASJON',
}

interface ITypeTilsynPayload {
  typeTilsyn: TyperTilsyn
}

interface ISakPayload {
  noarksakAar: string
  noarksakSekvensnummer: string
}

interface ITilsynsobjektPayload {
  isSelected: boolean
  orgNr: string
  virksomhetTilsynsobjekt:
    | IVirksomhetTilsynsobjekt
    | IMidlertidigTilsynsobjektPayload
}

export type ICreateKvitteringPayload = Prettify<
  ITypeTilsynPayload | ISakPayload | ITilsynsobjektPayload
>

export interface IUpdateKvitteringPayload {
  kvittering: IKvitteringData
}

export interface IFordelKvitteringTilKollegaPayload {
  ansatt: IOrgenhetRemote.Ansatt
}

export interface IHentKvitteringerFraKollegaPayload {
  begrunnelse: string
  kollega: string
  kvitteringIds: string[]
}
